"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSOutlook = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.314a.357.357 0 0 0-.17-.307h-.002l-.006-.004-5.545-3.282a.744.744 0 0 0-.831 0L3.902 8.003l-.007.004a.361.361 0 0 0 .009.619l5.544 3.282c.024.016.049.03.074.044a.744.744 0 0 0 .757-.044l5.544-3.282A.357.357 0 0 0 16 8.314Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.548 6.123h3.638v3.335H4.548V6.123Zm10.708-3.39V1.207A.691.691 0 0 0 14.58.5H5.14a.691.691 0 0 0-.675.707v1.526l5.581 1.488 5.21-1.488Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.465 2.733h3.72V6.08h-3.72V2.733Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.906 2.733h-3.72V6.08l3.72 3.35h3.35V6.08l-3.35-3.348Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.186 6.081h3.72v3.35h-3.72V6.08Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.186 9.43h3.72v3.35h-3.72V9.43Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.547 9.458h3.638v3.032H4.547V9.458Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.906 9.43h3.35v3.35h-3.35V9.43Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.83 8.605-.008.004-5.544 3.118a.773.773 0 0 1-.375.116l-.303-.177a.741.741 0 0 1-.074-.043L3.907 8.417h-.002l-.184-.103v6.312c.003.421.346.76.767.758h10.756c.006 0 .012-.003.019-.003a.943.943 0 0 0 .26-.055.762.762 0 0 0 .172-.099.751.751 0 0 0 .305-.6V8.313c0 .12-.066.232-.17.291Z",
    fill: "url(#icon_MSOutlook_".concat(randomId, "_a)")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.703 8.289v.387l-5.797 3.991L3.904 8.42a.004.004 0 0 0-.004-.003l-.55-.332v-.279l.227-.003.48.275.01.004.042.026 5.655 3.226.216.126c.019-.007.037-.015.06-.022l5.6-3.152.063.004Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.83 8.605-.008.004-5.544 3.118a.777.777 0 0 1-.831 0L3.903 8.61l-.007-.004a.335.335 0 0 1-.175-.291v6.312c.002.421.346.76.767.758h10.745a.762.762 0 0 0 .767-.758V8.314c0 .12-.066.232-.17.291Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m10.36 11.681-.083.047a.77.77 0 0 1-.367.12l2.11 2.494 3.68.886a.758.758 0 0 0 .232-.29L10.36 11.68Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "m10.736 11.47-.459.258a.77.77 0 0 1-.367.12l.988 2.724 4.802.655c.19-.142.3-.364.3-.6v-.082l-5.264-3.075Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.498 15.384h10.733a.772.772 0 0 0 .46-.15L9.6 11.668a.78.78 0 0 1-.075-.043L3.907 8.417h-.003l-.183-.103v6.29c0 .43.347.78.777.78Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.93 4.159v7.936a.684.684 0 0 1-.68.685H3.72V3.85h.745v-.372h3.784c.376.001.68.306.681.682Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.558 4.53v7.938c0 .09-.018.178-.056.26a.678.678 0 0 1-.625.423H3.721V3.85h4.156a.625.625 0 0 1 .309.078.676.676 0 0 1 .372.604Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.558 4.53v7.193a.687.687 0 0 1-.681.684H3.721V3.849h4.156a.625.625 0 0 1 .309.078.676.676 0 0 1 .372.604Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.186 4.53v7.193a.684.684 0 0 1-.681.684H3.72V3.849h3.784a.681.681 0 0 1 .68.682Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.682 3.849h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 11.353V4.53c0-.377.305-.682.682-.682Z",
    fill: "url(#icon_MSOutlook_".concat(randomId, "_b)")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.132 6.71c.168-.359.44-.658.78-.861a2.355 2.355 0 0 1 1.237-.31c.402-.01.798.093 1.146.294.327.195.59.48.758.822.183.377.274.791.266 1.21.008.437-.085.87-.274 1.265-.172.353-.443.65-.781.85a2.28 2.28 0 0 1-1.189.303 2.24 2.24 0 0 1-1.17-.298 1.997 1.997 0 0 1-.769-.824 2.59 2.59 0 0 1-.268-1.195 2.877 2.877 0 0 1 .264-1.257Zm.83 2.02c.09.226.242.423.439.566.2.14.44.213.685.206a1.2 1.2 0 0 0 .73-.212c.195-.144.343-.34.426-.567.093-.253.14-.52.136-.79a2.404 2.404 0 0 0-.128-.8 1.265 1.265 0 0 0-.412-.59 1.132 1.132 0 0 0-.725-.223 1.181 1.181 0 0 0-.7.208c-.2.144-.355.342-.447.571a2.27 2.27 0 0 0-.003 1.632V8.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.906 2.733h3.35V6.08h-3.35V2.733Z",
    fill: "#50D9FF"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOutlook_".concat(randomId, "_a"),
    x1: 9.86,
    y1: 8.314,
    x2: 9.86,
    y2: 15.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOutlook_".concat(randomId, "_b"),
    x1: 1.422,
    y1: 3.316,
    x2: 6.764,
    y2: 12.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })))));
});
var _default = MSOutlook;
exports["default"] = _default;